import React, { useState } from "react";
import { Box, Text, Button, Grid, Label, Flex, Modal, ErrorMsg } from "atoms";
import { FormInput, FormRadio } from "molecules";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import MemoClose from "assets/icons/Close";
import { InvitationSentModal } from "../InvitationSentModal";

const validationSchema = Yup.object().shape({
  location: Yup.string().required("Location is required"),
  isActive: Yup.boolean().required("Choose yes if location is active"),
});

export const AddNewLocationModal = ({
  isOpen,
  onClose,
  preLocation,
  onSubmit,
  loading,
  error,
  resetError,
}) => {
  const [isConfirmModalVisible, setConfirmModalVisible] = useState(false);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <Box width={{ md: "48.8rem" }}>
          <Box p={{ xs: "2.4rem", lg: "3.2rem" }}>
            <Flex
              justifyContent="space-between"
              borderBottom="0.1rem solid"
              borderColor="neutral.100"
              pb="2.4rem"
            >
              <Text
                fontSize="2rem"
                color="primary.900"
                fontFamily="primaryBold"
              >
                {preLocation ? "Edit" : "Add New"} Location
              </Text>
              <Box
                color="neutral.900"
                onClick={onClose}
                cursor="pointer"
                textAlign="right"
              >
                <MemoClose height="1.6rem" width="1.6rem" />
              </Box>
            </Flex>
            <Formik
              initialValues={{
                location: preLocation?.name || "",
                isActive:
                  typeof preLocation?.isActive === "boolean"
                    ? preLocation?.isActive
                    : "",
              }}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
              {({ values, setFieldValue, touched, errors }) => {
                return (
                  <Form>
                    <Grid gridRowGap="2.4rem" mt="1.8rem">
                      <Grid gridRowGap="1.6rem">
                        <Label text="Location" req />
                        <FormInput
                          name="location"
                          placeholder="Enter Location"
                          req
                          onChange={(e) => {
                            setFieldValue("location", e?.target?.value);
                            error && resetError();
                          }}
                        />
                      </Grid>

                      <Flex aI="center" gridGap="3rem">
                        <Label text="Active" req />
                        <FormRadio name="isActive" label="Yes" value={true} />
                        <FormRadio name="isActive" label="No" value={false} />
                      </Flex>
                      {touched?.isActive && errors?.isActive && (
                        <ErrorMsg text={errors?.isActive} />
                      )}

                      {error && <ErrorMsg text={error} />}

                      <Button
                        variant="primary"
                        type="submit"
                        height={{ xs: "4.3rem", lg: "4.8rem" }}
                        loading={loading}
                      >
                        Save
                      </Button>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </Box>
        </Box>
      </Modal>
      {isConfirmModalVisible && (
        <InvitationSentModal
          isOpen={isConfirmModalVisible}
          onClose={() => setConfirmModalVisible(false)}
        />
      )}
    </>
  );
};
